import { haptic } from '../lib/share'

export function DigitPad({ digit, onDigit, canLock, onLock }: { digit: number | null; onDigit: (d: number) => void; canLock: boolean; onLock: () => void }) {
  return (
    <div className="pad">
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((d) => (
        <button key={d} className={digit === d ? 'on' : ''} onClick={() => { haptic(10); onDigit(d) }} aria-label={`digit ${d}`}>{d}</button>
      ))}
      <button className="lock" disabled={!canLock} onClick={onLock}>Lock in →</button>
    </div>
  )
}
